// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class QuoteLossReason {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly isSystem: boolean;
  readonly priority: number;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.description = data.description === undefined ? '' : data.description;
    this.isSystem = data.isSystem === undefined ? false : data.isSystem;
    this.priority = data.priority === undefined ? 0 : data.priority;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): QuoteLossReason {
    const zeroValues: ExcludeMethodsDeep<QuoteLossReason> = {
      id: NIL_UUID,
      name: '',
      description: '',
      isSystem: false,
      priority: 0,
      isArchived: false,
    };
    return new QuoteLossReason(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteLossReasonWireFormat = {
  id: string;
  name: string;
  description: string;
  isSystem: boolean;
  priority: number;
  isArchived: boolean;
};

type NewQuoteLossReasonProps = PartialDeep<QuoteLossReason, { recurseIntoArrays: true }>;
export const NewQuoteLossReason: (props: NewQuoteLossReasonProps) => QuoteLossReason = (props) =>
  new QuoteLossReason(props);

type NewQuoteLossReasonFromWireFormatProps = PartialDeep<
  QuoteLossReasonWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteLossReasonFromWireFormat: (
  props: NewQuoteLossReasonFromWireFormatProps,
) => QuoteLossReason = (props) => new QuoteLossReason(props);
